// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"23afd126","359":"6884e750","643":"8e118038"}[chunkId] + ".chunk.css";
};